import React, { useState, useEffect, useref } from 'react';
import { Link } from 'react-router-dom';
import './styles.css'
import * as AiIcons from 'react-icons/ai';
import * as FcIcons from 'react-icons/fc';
import * as VscIcons from 'react-icons/vsc';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import AuthService from "../services/auth.service";
import AxiosService from "../services/axios.service";
import { Modal, Button } from "react-bootstrap";
import DatePicker from "react-datepicker";
import $ from 'jquery';
const API_PATH = "requests";

function ListRequests(match) {
    const { path } = match;

    const [requests, setRequests] = useState(null);
    const [all, setAll] = useState(null);
    const [active_requests, setActive] = useState(null);
    const [archived, setArchived] = useState(null);
    const [litigation, setLitigation] = useState(null);

    const [mod, setMod] = useState(false);
    const [admin, setAdmin] = useState(false);
    const [status, setStatus] = useState("All");
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());

    const radios = [
        { name: 'All', value: '1' },
        { name: 'Active', value: '2' },
        { name: 'Archived', value: '3' },
        { name: 'Litigation', value: '4' },
    ];

    const { register, watch, formState: { errors }, handleSubmit } = useForm();
    const [deleteId, setDeleteId] = useState(0);
    const [show, setShow] = useState(false);

    const handleClose = () => {
        setShow(false);
        console.log("close");
    };

    const confirmDelete = (id) => {
        setShow(true);
        setDeleteId(id);
    };

    function deleteRequest() {
        console.log("deleting request id: " + deleteId);
        setRequests(requests.map(x => {
            if (x.id === deleteId) { x.isDeleting = true; }
            return x;
        }));
        AxiosService.delete(API_PATH, deleteId).then(() => {
            setRequests(requests => requests.filter(x => x.id !== deleteId));
        });
        setShow(false);
    };

    useEffect(() => {
        const user = AuthService.getCurrentUser();
        if (user) {
            setMod(user.roles.includes("ROLE_MODERATOR"));
            setAdmin(user.roles.includes("ROLE_ADMIN"));
        }
        AxiosService.getAll(API_PATH).then(x => {

            // for (var j in x.data) {
            //     var agency_names_to_string = "";
            //     var agencies = x.data[j].agency;
            //     for (var i in agencies) {
            //         console.log(agencies[i].name);
            //         agency_names_to_string += agencies[i].name + " ";
            //     }
            //     console.log(agency_names_to_string);
            //     x.data[j].agencies = agency_names_to_string
            // }

            setAll(x.data);

            var active_requests = x.data.filter(({ category }) => category === 'Active');
            setActive(active_requests);

            var archived_cases = x.data.filter(({ category }) => category === 'Archive');
            setArchived(archived_cases);

            var litigation_cases = x.data.filter(({ category }) => category === 'Litigation');
            setLitigation(litigation_cases);

            setRequests(active_requests);
            setStatus("Active");
        }
        );
    }, []);

    function filterDates(endDate) {
        setEndDate(endDate);
        //make this work by filters
        var filtered_cases = [];

        switch (status) {
            case "All":
                filtered_cases = all;
                break;
            case "Active":
                filtered_cases = active_requests;
                break;
            case "Archive":
                filtered_cases = archived;
                break
            case "Litigation":
                filtered_cases = litigation;
                break;
        }
        var ranges = filtered_cases.filter(req => req.submission_date >= startDate.toISOString().slice(0, 10) && req.submission_date <= endDate.toISOString().slice(0, 10))
        ranges.sort((a, b) => new Date(a.submission_date) - new Date(b.submission_date));
        setRequests(ranges);
    }

    function search() {

        var keyword = watch("query").toLowerCase();
        var filtered_cases = [];

        switch (status) {
            case "All":
                filtered_cases = all;
                break;
            case "Active":
                filtered_cases = active_requests;
                break;
            case "Archive":
                filtered_cases = archived;
                break
            case "Litigation":
                filtered_cases = litigation;
                break;
        }

        var results = filtered_cases.filter(item => item.agency.toLowerCase().includes(keyword) || item.agency_tracking_numbers.toLowerCase().includes(keyword) || item.current_status.toLowerCase().includes(keyword) || item.subject.toLowerCase().includes(keyword) || item.short_description.toLowerCase().includes(keyword) || JSON.stringify(item.documents).toLowerCase().includes(keyword) || JSON.stringify(item.agency_contacts).toLowerCase().includes(keyword))
        setRequests(results);
    }

    function getAllRequests() {
        setStatus("All");
        setRequests(all);
    }

    function getActiveRequests() {
        setStatus("Active");
        setRequests(active_requests);
    }

    function getArchivedRequests() {
        setStatus("Archive");
        setRequests(archived);
    }

    function getLitigation() {
        setStatus("Litigation");
        setRequests(litigation);
    }
    $('button').on('click', function () {
        $('button').removeClass('active');
        $(this).addClass('active');
    });

    <script src="https://ajax.googleapis.com/ajax/libs/jquery/2.1.1/jquery.min.js"></script>

    return (

        <div>
            <h1 style={{ textAlign: 'center' }}>Investigations Requests</h1>
            <link href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" rel="stylesheet" />
            <script src="https://code.jquery.com/jquery-3.1.1.js"></script>
            <script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js"></script>

            {(mod || admin) && (
                <Link to={`/requests/add`} className="btn btn-sm btn-success mb-2">Add Request</Link>
            )}
            {/** Search Functionality */}
            <form onSubmit={handleSubmit(search)} onReset={getAllRequests}>
                <div className="form-row">
                    <div className="form-group col-5">
                        <input name="query" type="text" ref={register} {...register("query", {})} className={`form-control ${errors.query ? 'is-invalid' : ''}`} />
                        <div className="invalid-feedback">{errors.query?.message}</div>
                    </div>
                    <div className="form-group col-5">
                        {/*<button onClick={search} style={{ marginRight: 8 }} class="btn btn-light" id="search">Search <FcIcons.FcSearch size={24} /></button>*/}
                        <button class="btn btn-light" type="submit">Search <FcIcons.FcSearch size={24} /></button>
                    </div>
                </div>
            </form>
            <text>Results: {requests ? requests.length : 0}</text>
            <div class="btn-toolbar" role="toolbar" id="lettersToolbar" style={{ marginBottom: 5 }}>
                <div class="btn-group mr-2">

                    <button onClick={getAllRequests} style={{ marginRight: 8 }} class="btn btn-info" id="ALL">ALL</button>
                    <button checked={true} onClick={getActiveRequests} style={{ marginRight: 8 }} class="btn btn-info active" id="D">Active</button>
                    <button onClick={getArchivedRequests} style={{ marginRight: 8 }} class="btn btn-info" id="M">Archived</button>
                    <button onClick={getLitigation} style={{ marginRight: 8 }} class=" btn btn-info" id="S">Litigation</button>
                    <DatePicker
                        className={`form-control ${errors.query ? 'is-invalid' : ''}`}
                        dateFormat="MM-dd-yyyy"
                        selected={startDate}
                        selectsStart
                        startDate={startDate}
                        endDate={endDate}
                        onChange={date => setStartDate(date)}
                    />
                    <DatePicker
                        className={`form-control ${errors.query ? 'is-invalid' : ''}`}
                        dateFormat="MM-dd-yyyy"
                        selected={endDate}
                        selectsEnd
                        startDate={startDate}
                        endDate={endDate}
                        minDate={startDate}
                        onChange={date => filterDates(date)/*setEndDate(date)*/}
                    />
                </div>
            </div>
            <table className="table table-bordered table-hover table-hover-cursor">
                <thead>
                    <tr >

                        <th /*onClick={sortCaseName}*/ style={{ width: '10%', cursor: "pointer" }}>Agency</th>
                        <th /*onClick={sortStaffMember}*/ style={{ width: '10%', cursor: "pointer" }}>Agency Tracking Numbers</th>
                        <th style={{ width: '25%' }}>Current Status</th>
                        <th style={{ width: '30%' }}>Subject</th>
                        <th style={{ width: '25%' }}>Details</th>
                    </tr>
                </thead>
                <tbody class="searchable">
                    {requests && requests.map(request =>
                        <tr key={request.id}>

                            <td>{request.agency}</td>
                            {/* <td>{case_.case_id}</td> */}
                            <td>{request.agency_tracking_numbers}</td>
                            <td> <td style={{ whiteSpace: 'pre-line' }} className='desc'>{request.current_status}</td>
                            </td>
                            <td> <td style={{ whiteSpace: 'pre-line' }} className='truncate'>{request.subject}</td>
                            </td>
                            <td> <td style={{ whiteSpace: 'pre-line' }} className='truncate'>{request.current_status}</td>
                            </td>
                            <td style={{ whiteSpace: 'nowrap' }}>


                                <Link to={`/requests/view/${request.id}`} className="btn btn-sm btn-info mr-2"> <VscIcons.VscOpenPreview size={22} /> </Link>
                                {(mod || admin) && (
                                    <Link to={`/requests/edit/${request.id}`} className="btn btn-sm btn-primary mr-2"> <AiIcons.AiTwotoneEdit size={22} /> </Link>
                                )}


                                {admin && (
                                    <button
                                        className="btn btn-sm btn-danger mr-2"
                                        onClick={() => confirmDelete(request.id)}
                                    >
                                        <AiIcons.AiFillDelete size={22} />
                                    </button>

                                )}


                            </td>

                        </tr>

                    )}
                    {!requests &&
                        <tr>
                            <td colSpan="4" className="text-center">
                                <div className="spinner-border spinner-border-lg align-center"></div>
                            </td>
                        </tr>
                    }
                    {requests && !requests.length &&
                        <tr>
                            <td colSpan="4" className="text-center">
                                <div className="p-2">No Requests To Display</div>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Delete?</Modal.Title>
                </Modal.Header>
                <Modal.Body>Would you like to delete this Request?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => deleteRequest(requests.id)}>
                        OK
                    </Button>
                    <Button variant="primary" onClick={handleClose}>
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
        </div >



    );
}

export { ListRequests };